export class TextStyle {
    constructor() {
        this.font = "";
        this.fontSize = 12;
        this.color = "#000000";
        this.bold = false;
        this.italic = false;
        this.underline = false;
        this.strikethrough = false;
        this.align = 'left';
        this.valign = 'top';
        this.alignItems = "middle";
        this.leading = 2;
        this.letterSpacing = 0;
        this.stroke = 0;
        this.strokeColor = '#000000';
        this.shadowOffsetX = 0;
        this.shadowOffsetY = 0;
        this.shadowBlur = 0;
        this.shadowColor = '#000000';
    }
}
